"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = exports.CLOCK_HAND_CIRCLE_BACKGROUND = exports.CLOCK_HAND_ARM = exports.CLOCK_WRAPPER_BACKGROUND = void 0;
// clock wrapper
var CLOCK_WRAPPER_BACKGROUND = '#f4f4f4'; // clock

exports.CLOCK_WRAPPER_BACKGROUND = CLOCK_WRAPPER_BACKGROUND;
var CLOCK_HAND_ARM = '#bceaff';
exports.CLOCK_HAND_ARM = CLOCK_HAND_ARM;
var CLOCK_HAND_CIRCLE_BACKGROUND = '#e6f7ff';
exports.CLOCK_HAND_CIRCLE_BACKGROUND = CLOCK_HAND_CIRCLE_BACKGROUND;
var CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = '#ade2fb';
exports.CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND;


//////////////////
// WEBPACK FOOTER
// ./~/react-timekeeper/lib/components/styles/constants.js
// module id = 1641
// module chunks = 39